export default "__VITE_ASSET__BUQfLwQY__"